import React, { Component } from 'react';

class AutoCompleteSuggestions extends Component {
    render() {
        return (
            <div className="auto-complete-suggestions">
              {this.props.suggestions.map(
                  s => <div className="suggestion">{s}</div>)}
            </div>
        );
    }
}

export default AutoCompleteSuggestions;
